export default __webpack_public_path__ + "static/media/qr-badge.068954da.svg";